'use client';
import { motion } from 'framer-motion';
import { Search, Mail, Sparkles, MapPin, Home } from 'lucide-react';
import { useLanguage } from '@/app/context/language-context';

const NoResultsFound = ({ onContactClick, setSearchQuery, inputRef }) => {
  const { t } = useLanguage();

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 300, damping: 24 },
    },
  };

  return (
    <motion.div
      className='py-8 px-6 text-center'
      initial='hidden'
      animate='visible'
      variants={containerVariants}
    >
      <motion.div
        className='inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-primarycolor to-secondarycolor mb-4'
        variants={itemVariants}
      >
        <Sparkles className='w-8 h-8 text-white' />
      </motion.div>

      <motion.h3
        className='text-xl font-bold text-gray-900 dark:text-white mb-3'
        variants={itemVariants}
      >
        Your Dream Property Awaits!
      </motion.h3>

      <motion.p
        className='text-gray-600 dark:text-gray-300 mb-6 max-w-md mx-auto'
        variants={itemVariants}
      >
        We couldn't find any properties matching your search, but our exclusive
        portfolio is constantly growing. Let's find your perfect match together!
      </motion.p>

      <motion.div
        // className='grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md mx-auto mb-6'
        className='hidden sm:grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md mx-auto mb-6'
        variants={itemVariants}
      >
        <div className='bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow'>
          <MapPin className='w-5 h-5 text-primarycolor dark:text-secondarycolor mb-2 mx-auto' />
          <h4 className='font-medium text-gray-900 dark:text-white mb-1'>
            Try Different Areas
          </h4>
          <p className='text-sm text-gray-500 dark:text-gray-400'>
            Expand your search to nearby neighborhoods
          </p>
        </div>

        <div className='bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow'>
          <Home className='w-5 h-5 text-primarycolor dark:text-secondarycolor mb-2 mx-auto' />
          <h4 className='font-medium text-gray-900 dark:text-white mb-1'>
            Adjust Criteria
          </h4>
          <p className='text-sm text-gray-500 dark:text-gray-400'>
            Modify your filters for more options
          </p>
        </div>
      </motion.div>

      <motion.div
        className='flex flex-col sm:flex-row items-center justify-center gap-4'
        variants={itemVariants}
      >
        <button
          onClick={() => {
            setSearchQuery('');
            inputRef.current?.focus();
          }}
          className='px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors flex items-center'
        >
          <Search className='w-4 h-4 mr-2' />
          Start a new search
        </button>

        <button
          onClick={onContactClick}
          // className='px-4 py-2 bg-gradient-to-r from-primarycolor to-secondarycolor text-white rounded-full hover:shadow-lg transition-shadow flex items-center'
          className='px-4 py-2  bg-primarycolor hover:bg-secondarycolor text-white hover:text-black rounded-full hover:shadow-lg transition-shadow flex items-center'
        >
          <Mail className='w-4 h-4 mr-2' />
          Get personalized recommendations
        </button>
      </motion.div>
    </motion.div>
  );
};

export default NoResultsFound;
